// src/components/ui/PageLoader.jsx
import PropTypes from 'prop-types'
import { RefreshCw } from 'lucide-react'
import { cn } from '../../utils/cn'

const PageLoader = ({ 
  title = 'Loading...', 
  subtitle = '', 
  className = '',
  containerClassName = '',
  showHeader = true,
  headerTitle = '',
  size = 'lg'
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  }

  return (
    <div className={cn("min-h-screen bg-gray-50 p-6", containerClassName)}>
      <div className="max-w-7xl mx-auto">
        {showHeader && (
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">{headerTitle}</h1>
            </div>
          </div>
        )}
        <div className={cn("flex items-center justify-center py-12", className)}>
          <div className="text-center">
            <RefreshCw className={cn(
              "animate-spin text-orange-500 mx-auto mb-2",
              sizeClasses[size]
            )} />
            <p className="text-gray-500">{title}</p>
            {subtitle && (
              <p className="text-gray-400 text-sm mt-1">{subtitle}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

PageLoader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  showHeader: PropTypes.bool,
  headerTitle: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl'])
}

export default PageLoader
